// extracted by mini-css-extract-plugin
export default {"melodyVideo":"LO-z","isFullWidth":"MO-z","landingPageVideo":"NO-z","play":"OO-z","iframeVideo":"PO-z","playHidden":"QO-z","fullwidth":"RO-z"};